import { SVGFC } from '@repo/toolkit/types'

const LoginGroupFiveIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="198"
      height="37"
      viewBox="0 0 198 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="7" cy="7" r="7" fill={color} />
      <circle cx="30" cy="7" r="7" fill={color} />
      <circle cx="53" cy="7" r="7" fill={color} />
      <circle cx="76" cy="7" r="7" fill={color} />
      <circle cx="99" cy="7" r="7" fill={color} />
      <circle cx="122" cy="7" r="7" fill={color} />
      <circle cx="145" cy="7" r="7" fill={color} />
      <circle cx="168" cy="7" r="7" fill={color} />
      <circle cx="191" cy="7" r="7" fill={color} />
      <circle cx="7" cy="30" r="7" fill={color} />
      <circle cx="30" cy="30" r="7" fill={color} />
      <circle cx="53" cy="30" r="7" fill={color} />
      <circle cx="76" cy="30" r="7" fill={color} />
      <circle cx="99" cy="30" r="7" fill={color} />
      <circle cx="122" cy="30" r="7" fill={color} />
      <circle cx="145" cy="30" r="7" fill={color} />
      <circle cx="168" cy="30" r="7" fill={color} />
      <circle cx="191" cy="30" r="7" fill={color} />
    </svg>
  )
}

export default LoginGroupFiveIcon
